import { css } from "lit";

export const styles = css`
  :host {
    display: flex;
    flex-direction: column;
    height: 100%;
    background: var(--sds-color-background-default-default);
  }

  .page-header {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    background: var(--sds-color-black-1000);
    flex-shrink: 0;
    gap: 12px;
  }

  .mobile-only {
    display: none;
  }

  .close-btn {
    display: none;
  }

  .mobile-side-controls {
    display: none;
  }

  .duration {
    font: var(--sds-typography-weight-medium) var(--sds-typography-scale-02) var(--sds-typography-family-body);
    color: var(--sds-color-text-default-secondary);
    font-variant-numeric: tabular-nums;
  }

  .obs-hint {
    font: var(--sds-typography-weight-medium) var(--sds-typography-scale-03) var(--sds-typography-family-title);
    color: var(--sds-color-text-default-default);
  }

  .streaming-content {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    overflow: hidden;
  }

  .live-content {
    display: flex;
    flex-direction: row;
    flex: 1;
    gap: 0;
    min-height: 0;
    align-items: stretch;
  }

  .video-section {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-width: 0;
    min-height: 0;
    background: var(--sds-color-black-1000);
  }

  .video-container {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    background: var(--sds-color-black-1000);
    overflow: hidden;
    min-height: 0;
    position: relative;
  }

  .video-container stream-recorder,
  .video-container cdn-player {
    width: 100%;
    height: 100%;
    background: var(--sds-color-black-1000);
  }

  .chat-panel {
    display: flex;
    flex-direction: column;
    width: 320px;
    min-width: 280px;
    border-left: 1px solid var(--sds-color-border-default-default);
  }

  .chat-panel-heading {
    margin: 0;
    padding: 12px 16px;
    font: var(--sds-typography-weight-medium) var(--sds-typography-scale-04) var(--sds-typography-family-title);
    color: var(--sds-color-text-default-default);
    flex-shrink: 0;
  }

  /* Tab bar */
  .chat-panel-tab-bar {
    display: flex;
    border-bottom: 1px solid var(--sds-color-border-default-default);
    flex-shrink: 0;
  }

  .chat-panel-tab-bar button {
    padding: 12px 16px;
    background: none;
    border: none;
    border-bottom: 2px solid transparent;
    cursor: pointer;
    font: var(--sds-typography-weight-regular) var(--sds-typography-scale-02) var(--sds-typography-family-title);
    color: var(--sds-color-text-default-secondary);
  }

  .chat-panel-tab-bar button.active {
    border-bottom-color: var(--sds-color-text-default-default);
    color: var(--sds-color-text-default-default);
  }

  .chat-panel-tab-bar button:disabled {
    opacity: 0.4;
    cursor: default;
    pointer-events: none;
  }

  /* Tab content */
  .chat-tab-content {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    padding: 16px;
    padding-right: 40px;
    box-sizing: border-box;
  }

  live-chat {
    flex: 1;
    min-height: 0;
  }

  .preview-controls {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 12px 16px;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
  }

  live-badge {
    --live-badge-padding: 6px 14px;
  }

  .preview-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    border-top: 1px solid var(--sds-color-border-default-default);
    background: var(--sds-color-background-default-default);
    flex-shrink: 0;
  }

  /* Page-level footer (shown when not live, outside .live-content) */
  .page-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    border-top: 1px solid var(--sds-color-border-default-default);
    background: var(--sds-color-background-default-default);
    flex-shrink: 0;
  }

  .page-footer live-badge {
    --live-badge-indicator-display: none;
  }

  .live-footer-actions {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .live-footer-row {
    display: none;
  }

  .preview-footer-info {
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 0;
    flex: 1;
  }

  .preview-footer-title {
    font: var(--sds-typography-weight-regular) var(--sds-typography-scale-02) var(--sds-typography-family-body);
    color: var(--sds-color-text-default-default);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0;
  }

  .error-banner {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
    background: var(--sds-color-background-danger-subtle);
    color: var(--sds-color-text-danger-default);
    border-radius: var(--sds-size-radius-200);
    font: var(--sds-typography-weight-regular) var(--sds-typography-scale-01) var(--sds-typography-family-body);
  }

  .connecting-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    padding: 40px;
    flex: 1;
    color: var(--sds-color-text-default-secondary);
    font: var(--sds-typography-weight-medium) var(--sds-typography-scale-02) var(--sds-typography-family-body);
  }

  .spinner {
    width: 40px;
    height: 40px;
    border: 3px solid var(--sds-color-border-default-default);
    border-top-color: var(--sds-color-border-brand-default);
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }

  /* Stream settings content */
  .stream-settings-container {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .form-section {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  /* OBS Configuration */
  .obs-config-content {
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 0;
  }

  .obs-steps {
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-top: 8px;
  }

  .obs-step {
    display: flex;
    gap: 16px;
    align-items: flex-start;
  }

  .step-number {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: var(--sds-color-background-default-default);
    color: var(--sds-color-text-default-default);
    border: 2px solid var(--sds-color-border-default-default);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    font: var(--sds-typography-weight-semibold) var(--sds-typography-scale-01) var(--sds-typography-family-body);
  }

  .step-content {
    display: flex;
    flex-direction: column;
    gap: 8px;
    flex: 1;
  }

  .step-title {
    font: var(--sds-typography-weight-semibold) var(--sds-typography-scale-02) var(--sds-typography-family-body);
    color: var(--sds-color-text-default-default);
  }

  .step-description {
    font: var(--sds-typography-weight-regular) var(--sds-typography-scale-01) var(--sds-typography-family-body);
    color: var(--sds-color-text-default-secondary);
    line-height: 150%;
  }

  .obs-credential-row {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .obs-credential-value {
    flex: 1;
    font: var(--sds-typography-weight-regular) var(--sds-typography-scale-01) var(--sds-typography-family-mono);
    color: var(--sds-color-text-default-default);
    background: var(--sds-color-background-default-tertiary);
    padding: 12px 16px;
    border-radius: var(--sds-size-radius-300);
    border: 1px solid var(--sds-color-border-default-default);
    overflow: hidden;
    word-break: break-all;
  }

  .obs-credential-value.masked {
    letter-spacing: 2px;
  }

  .obs-credential-value-wrapper {
    flex: 1;
    position: relative;
    display: flex;
    align-items: center;
  }

  .obs-credential-value-wrapper .obs-credential-value {
    flex: 1;
    padding-right: 48px;
  }

  .obs-credential-value-wrapper .stream-key-toggle {
    position: absolute;
    right: 8px;
  }

  .problem-link {
    color: var(--sds-color-text-brand-default);
    text-decoration: underline;
    cursor: pointer;
  }

  .problem-link:hover {
    text-decoration: none;
  }

  /* Camera permission status */
  .permission-status {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px;
    border-radius: var(--sds-size-radius-400);
    font: var(--sds-typography-weight-medium) var(--sds-typography-scale-01) var(--sds-typography-family-body);
  }

  .permission-status.granted {
    background: var(--sds-color-background-success-subtle);
    color: var(--sds-color-text-success-default);
  }

  .permission-status.denied {
    background: var(--sds-color-background-danger-subtle);
    color: var(--sds-color-text-danger-default);
  }

  .permission-status.checking,
  .permission-status.prompt {
    background: var(--sds-color-background-default-secondary);
    color: var(--sds-color-text-default-secondary);
  }

  .permission-instructions {
    font-size: 0.8rem;
    color: var(--color-text-muted);
    margin-top: 4px;
    line-height: 1.4;
  }

  /* Mobile */
  @media (max-width: 768px) {
    .desktop-only {
      display: none;
    }

    .mobile-only {
      display: inline;
    }

    .close-btn {
      display: inline-flex;
    }

    .page-header {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      padding: 8px 12px;
      z-index: 2;
    }

    .streaming-content {
      overflow: hidden;
    }

    .live-content {
      flex-direction: column;
      width: 100%;
    }

    .video-section {
      flex: 1;
      min-height: 0;
      position: relative;
    }

    .preview-controls {
      display: none;
    }

    .mobile-side-controls {
      display: flex;
      gap: 8px;
      position: absolute;
      bottom: 12px;
      z-index: 1;
    }

    .chat-panel {
      display: none;
    }

    .is-live .chat-panel {
      display: flex;
      width: 100%;
      min-width: unset;
      border-left: none;
      flex: 1;
      min-height: 150px;
    }

    .is-live .chat-panel.chat-hidden {
      display: none;
    }

    .preview-footer {
      flex-direction: column;
      gap: 12px;
      padding: 12px 16px;
      align-items: stretch;
    }

    .page-footer {
      flex-direction: column;
      gap: 12px;
      padding: 12px 16px;
      align-items: stretch;
    }

    .live-footer-row {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      width: 100%;
    }

    .chat-panel-heading {
      display: none;
    }

    .chat-tab-content {
      padding: 12px;
      padding-bottom: 6px;
    }
  }

  /* Portrait mode - when live with chat visible, limit video to make room */
  @media (max-width: 768px) and (orientation: portrait) {
    .is-live .video-section {
      flex: 1;
      min-height: 0;
    }

    .is-live:has(.chat-panel:not(.chat-hidden)) .video-section {
      max-height: 50vh;
      flex: 0 0 auto;
    }
  }

  /* Landscape mode */
  @media (max-height: 500px) and (orientation: landscape) {
    .streaming-content {
      overflow: hidden;
    }

    .live-content {
      flex-direction: row;
      gap: 0;
      height: 100%;
    }

    .video-section {
      min-height: auto;
      height: 100%;
    }

    .chat-panel {
      display: none;
    }

    .is-live .chat-panel {
      display: flex;
      width: 280px;
      min-width: 240px;
      border-left: 1px solid var(--sds-color-border-default-default);
      border-top: none;
      height: 100%;
    }

    .error-banner {
      padding: 8px 12px;
      font-size: 12px;
    }

    .preview-footer {
      padding: 8px 12px;
    }

    .page-footer {
      padding: 8px 12px;
    }
  }

  /* Debug overlay */
  .debug-overlay {
    position: absolute;
    top: 8px;
    left: 8px;
    z-index: 3;
    background: rgb(0 0 0 / 0.85);
    color: #00ff00;
    font: 11px/1.5 var(--sds-typography-family-mono, monospace);
    padding: 12px;
    border-radius: 6px;
    pointer-events: none;
    max-width: 280px;
  }

  .debug-section {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }
`;
